import React, { useEffect, useState } from 'react';
import { Title } from '@cotera/client/app/components/ui';
import { Shimmer } from '@cotera/client/v0/components/ai-elements/shimmer';
import { cn } from '@cotera/client/v0/lib/utils';

const TYPING_SPEED_MS = 25;

export const TypingTitle: React.FC<{
  text: string;
  className?: string;
}> = ({ text, className }) => {
  const [displayedLength, setDisplayedLength] = useState(0);

  useEffect(() => {
    setDisplayedLength(0);
  }, [text]);

  useEffect(() => {
    if (displayedLength >= text.length) {
      return;
    }
    const id = setTimeout(() => {
      setDisplayedLength((prev) => prev + 1);
    }, TYPING_SPEED_MS);
    return () => clearTimeout(id);
  }, [displayedLength, text.length]);

  const displayed = text.slice(0, displayedLength);
  const isComplete = displayedLength >= text.length;
  const content = `${displayed}${!isComplete ? '|' : ''}`;

  return (
    <Title type="section" className={cn('text-center', className)}>
      {isComplete ? (
        displayed
      ) : (
        <Shimmer as="span" duration={2.5} spread={1.5}>
          {content}
        </Shimmer>
      )}
    </Title>
  );
};
